<template>
  <div class="bg-gray rounded p-2">
    <div class="bg-white rounded p-3">
      <div class="row">
        <div class="col-12">
          <span class="title d-flex align-items-center">
            <div class="circle-icon d-flex">
              <span class="fa-stack fa-1x">
                <i class="fas fa-circle fa-stack-2x text-white" />
                <i class="fas fa-file-plus fa-stack-1x text-orange" />
              </span>
            </div>
            <span>{{ title }}</span>
          </span>
        </div>
        <div class="col-12 ml-2">
          <div class="pt-3 px-3">
            <validation-observer ref="form" tag="div" class="row">
              <div v-show="true" class="col-12 mb-3">
                <RelatedServiceFormWrapper
                  :tap-request-id="tapRequestId"
                  :submitted="false"
                  :canEdit="true"
                  :saveLocally="true"
                  :hideActions="true"
                  :items="relatedServices"
                />
              </div>
              <div class="col-12 col-lg-4 pt-2 pt-0-lg">
                <validation-provider
                  v-slot="{ errors }"
                  mode="lazy"
                  rules="required"
                >
                  <custom-date-picker
                    v-model="model.date"
                    label="Fecha:"
                    placeholder="DD/MM/YYYY"
                    regular-label
                    :error="errors[0]"
                    custom-error-msg="La fecha es requerida."
                    :min-date="minAssignedDate"
                    :max-date="new Date()"
                    :disabled="readonly"
                  />
                </validation-provider>
              </div>
              <div class="col-12 col-lg-4 pt-2 pt-0-lg">
                <validation-provider
                  v-slot="{ errors }"
                  mode="lazy"
                  rules="required"
                >
                  <div
                    class="color-gray-6 font-14 font-weight-normal mb-1 pb-1"
                  >
                    Documento:
                  </div>
                  <div class="d-flex align-items-center">
                    <custom-file-input
                      ref="fileUpload"
                      v-model="model.document"
                      :attachment-id="model.documentId"
                      display-style="normal"
                      :on-download="downloadFile"
                      :accept="'.pdf'"
                      label-position="left"
                      :error="errors[0]"
                      custom-error-msg="El documento es requerido."
                      :disabled="readonly"
                    />
                    <div
                      class="color-gray-6 font-14 font-weight-normal mb-1 pb-1"
                    >
                      {{ model.documentName }}
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="col-12 col-lg-12 pt-2 pt-0-lg mt-3">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-text-area
                    v-model="model.comment"
                    label="Justificación Enmienda:"
                    :disabled="readonly"
                    :maxlength="3000"
                    show-char-count
                    :count-classes="['d-block text-right']"
                    :error="errors[0]"
                    custom-error-msg="La Justificación es requerido."
                  />
                </validation-provider>
              </div>
              <div class="col-12 col-lg-12 pt-2">
                <div
                  class="mt-2 d-flex flex-column flex-lg-row justify-content-lg-end"
                >
                  <action-button
                    v-if="!readonly"
                    text="Cancelar"
                    variant="outline-danger"
                    i="fas fa-times-circle"
                    class="w-auto w-lg-0"
                    @click="cancel"
                  />
                  <div class="my-1 mx-1 my-lg-0 mx-lg-2" />
                  <action-button
                    v-if="!readonly"
                    text="Guardar"
                    variant="success"
                    i="fas fa-save"
                    class="w-auto w-lg-0"
                    @click="onSave"
                  />
                </div>
              </div>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import ActionButton from 'ActionButton';
import CustomDatePicker from 'custom-date-picker';
import CustomFileInput from 'CustomFileInput';
import CustomTextArea from 'CustomTextArea';
import alert from '@/mixin/alert.mixin';
import objectToFormData from 'object-to-formdata';
import { saveAmendment } from '@/services/tapRequest';
import { servicesProvidedApi } from '@/components/pei/ubication-tech-assistance/_components/ServicesProvided/_api';
import documentsService from '@/services/documents';
import RelatedServiceFormWrapper from '@/components/pei/ubication-tech-assistance/_components/ServicesProvided/_components/RelatedServiceFormWrapper';

const initialModel = () => ({
  teacherId: null,
  assistantId: null,
  assignmentStartDate: null,
  placementId: null,
  activateAssistant: false,
  document: null,
  documentId: null,
});

export default {
  name: 'Amendment',
  components: {
    ActionButton,
    CustomDatePicker,
    CustomFileInput,
    CustomTextArea,
    RelatedServiceFormWrapper,
  },
  mixins: [alert],
  props: {
    title: {
      type: String,
      default: 'Enmendar',
    },
    tapRequestId: {
      type: [Number, String],
      required: true,
    },
    assignedDate: {
      type: [Date, String],
      default: null,
    },
    existingData: {
      type: Object,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: initialModel(),
      relatedServices: [],
    };
  },
  computed: {
    companyId() {
      return this.userProfile.companyid;
    },
    minAssignedDate() {
      return moment(this.assignedDate)
        .add(-1, 'days')
        .toDate();
    },
    relatedServicesToSave() {
      return this.relatedServices.filter((x) => x.id < 0);
    },
  },
  mounted() {
    if (this.existingData) {
      this.model = {
        ...this.existingData,
      };
    }
    this.getRelatedServices();
  },
  methods: {
    cancel(emit = true) {
      this.model = initialModel();
      this.$refs['form']?.reset();
      if (emit) {
        this.$emit('cancel');
      }
    },
    async onSave() {
      let valid = await this.$refs['form'].validate();
      if (valid) {
        let model = {
          requestId: this.tapRequestId,
          date: this.model.date,
          comment: this.model.comment,
          file: this.model.document,
          requestServices: this.relatedServicesToSave.map((x) => ({
            id: x.id,
            requestId: x.requestId,
            disciplineTypeId: x.service?.id,
            modalityTypeId: x.modality?.id,
            durationTypeId: x.duration?.id,
            frequencyTypeId: x.frequency?.id,
            serviceTime: x.dutyTime,
            approachTypeId: x.approach?.id,
          })),
        };

        const formData = objectToFormData(model, { indices: true });

        await saveAmendment(formData)
          .then(() => {
            this.ShowToast(
              '',
              'La solicitud ha sido enmendada exitosamente.',
              'success'
            );
            this.$emit('success');
          })
          .catch(() => {
            this.ShowToast(
              'Error',
              'Se ha producido un error al intentar enmendar la solicitud.',
              'error'
            );
          });
      }
    },
    downloadFile(attachmentId) {
      return documentsService.downloadFromServer(attachmentId);
    },
    async getRelatedServices() {
      const result = await servicesProvidedApi.getAll(this.tapRequestId);
      if (result?.length > 0 ?? false) {
        this.relatedServices = result.filter((x) => x.isValidForTapRelated);
      }
    },
  },
};
</script>
